module.exports = __webpack_public_path__ + "img/classroomlight-k.8108d51e.png";